/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { UserActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        user: state.user
    });
}

function mapDispatchToProps(dispatch) {

    return {
		getUser: () => {
			dispatch(UserActions.fetchUser());
		},
		getUserPerms: () => {
			dispatch(UserActions.fetchPerms());
		},
		getUserPlan: () => {
			dispatch(UserActions.fetchPlan());
		},
        updateUser: (user) => {
            dispatch(UserActions.updateUser(user));
        },
        deleteUser: (id) => {
            dispatch(UserActions.deleteUser(id));
        },
        getAPIKey: () => {
            dispatch(UserActions.fetchAPIKey());
        },
        detachClient: () => {
            dispatch(UserActions.detachClient());
        }
	};
}

export default function UserProvider(Component) {

    class UserProvider extends React.Component {
        render() {
            return (
                <Component {...this.props}/>
            );
        }
    }

    UserProvider.displayName = "UserProvider";

    return connect(mapStateToProps, mapDispatchToProps)(UserProvider);
};
